// @flow
import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router-dom'
import { compose, withProps } from 'recompose'
import { t } from '../../core/i18n'
import { register } from './actions'
import Register from '../../ui/forms/register-form'
import {
  validateEmail,
  validateRequired,
  validatePassword,
  validateConfirmPassword
} from '../validations/validations'

const form = reduxForm({
  form: 'register',
  //validateOnBlur: true,
  initialValues: {
    acceptTerms: false
  },
  validate: values => ({
    email: validateEmail(values.email) || undefined,
    name: validateRequired(values.name),
    lastName: validateRequired(values.lastName),
    password: validatePassword(values.password),
    confirmPassword: validateConfirmPassword(
      values.password,
      values.confirmPassword
    ),
    acceptTerms: !Boolean(values.acceptTerms) && 'You must accept the terms'
  }),
  onSubmit(values, dispatch, props) {
    const { history } = props
    return dispatch(register(values)).then(() => {
      console.log('Register and logged in')
      history.replace('/register-success')
    })
  }
})

const withTranslations = withProps(props => ({
  translations: {
    emailLabel: t('app:forms.field.email.label'),
    emailPlaceholder: t('app:forms.field.email.placeholder'),
    nameLabel: t('app:forms.field.name.label'),
    namePlaceholder: t('app:forms.field.name.placeholder'),
    lastNameLabel: t('app:forms.field.lastName.label'),
    lastNamePlaceholder: t('app:forms.field.lastName.placeholder'),
    passwordLabel: t('app:forms.field.password.label'),
    passwordPlaceholder: t('app:forms.field.password.placeholder'),
    confirmPasswordLabel: t('app:forms.field.confirmPassword.label'),
    confirmPasswordPlaceholder: t(
      'app:forms.field.confirmPassword.placeholder'
    ),
    haveReadConditionsText: t('app:register.haveReadConditions'),
    createAccountButton: t('app:button.createAccount'),
    faceBookSignInButton: t('app:button.facebookSignIn'),
    haveAccountText: t('app:register.haveAccount'),
    signIn: t('common:signIn')
  }
}))

export const decorate = compose(withRouter, form, withTranslations)

export default decorate(Register)



// WEBPACK FOOTER //
// ./src/services/session/register-form.js